import { ObjectValues } from 'types';

export const FILE_TYPES = {
  IMAGE_AVIF: 'image/avif',
  IMAGE_JPEG: 'image/jpeg',
  IMAGE_PNG: 'image/png',
  IMAGE_BMP: 'image/bmp',
  IMAGE_WEBP: 'image/webp',
  DOCUMENT_DOC: 'application/msword',
  DOCUMENT_DOCX:
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  PDF: 'application/pdf',
  DOCUMENT_PPT: 'application/vnd.ms-powerpoint',
  DOCUMENT_PPTX:
    'application/vnd.openxmlformats-officedocument.presentationml.presentation',
  DOCUMENT_XLS: 'application/vnd.ms-excel',
  DOCUMENT_XLSX:
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  DOCUMENT_CSV: 'text/csv',
  VIDEOS: 'video/*',
  EML: 'message/rfc822',
  DWG: 'image/vnd.dwg',
  DWG_ALT: 'application/acad',
  DWG_ALT2: 'application/x-dwg',
  DWG_ALT3: 'application/dwg',
  DWG_ALT4: 'image/x-dwg',
  DWG_ALT5: 'application/x-autocad',
  IMAGE_TIFF: 'image/tiff',
} as const;

export const FILE_EXTENSIONS = {
  DWG: '.dwg',
  TIF: '.tif',
} as const;

export type FileTypes = ObjectValues<typeof FILE_TYPES>;

export const ACCEPTED_FILE_TYPES = [
  ...Object.values(FILE_TYPES),
  ...Object.values(FILE_EXTENSIONS),
];

export const ONE_GB = 2 << 29;

export const MAX_SIZE_GB = 15;
export const MAX_SIZE = MAX_SIZE_GB * ONE_GB;
export const MAX_SIZE_COPY = `${MAX_SIZE_GB}GB`;

export const MAX_FILES = 200;
